import { useMemo } from '@wordpress/element';
import * as styles from '../styles';
import { useContextSystem } from '../../context';
import { useCx } from '../../utils/hooks/use-cx';
export function useBorderBoxControlLinkedButton(props) {
  const {
    className,
    ...otherProps
  } = useContextSystem(props, 'BorderBoxControlLinkedButton');

  // Generate class names.
  const cx = useCx();
  const classes = useMemo(() => {
    return cx(styles.borderBoxControlLinkedButton, className);
  }, [className, cx]);
  return {
    ...otherProps,
    className: classes
  };
}